import { Heading } from '../../r2/Heading';
import { Text } from '../../r2/Text';
import { Badge } from '../../r2/Badge';
import styles from './LayerCard.module.css';

export interface LayerCardProps {
  layer: string;
  name: string;
  description: string;
  examples: string[];
  active?: boolean;
}

const LAYER_VARIANT: Record<string, 'default' | 'success' | 'warning' | 'danger'> = {
  r1: 'danger',
  r2: 'warning',
  r3: 'default',
  r4: 'success',
  r5: 'default',
  r6: 'default',
  r7: 'default',
};

export function LayerCard({
  layer,
  name,
  description,
  examples,
  active = false,
}: LayerCardProps) {
  return (
    <div
      data-crd-id="r3.bq-layer-card"
      data-crd-layer="r3"
      className={`${styles.card} ${active ? styles.active : ''}`}
    >
      <div className={styles.header}>
        <Badge variant={LAYER_VARIANT[layer] ?? 'default'}>
          {layer.toUpperCase()}
        </Badge>
        <Heading level={3} as={4}>
          {name}
        </Heading>
      </div>
      <Text size="r2" color="n500">
        {description}
      </Text>
      {examples.length > 0 && (
        <div className={styles.examples}>
          {examples.map((ex) => (
            <span key={ex} className={styles.tag}>
              {ex}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
